import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { RouteReuseStrategyService } from '../../services/route-reuse-strategy-service/route-reuse-strategy-service.service';

@Component({
  selector: 'app-virtual-event-atendee-page',
  templateUrl: './virtual-event-atendee-page.component.html',
  styleUrls: ['./virtual-event-atendee-page.component.scss']
})
export class VirtualEventAtendeePageComponent implements OnInit, AfterViewInit, OnDestroy {

  private takeUntilSubject: Subject<any> = new Subject();
  private takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();
  
  constructor(
    private route: ActivatedRoute,
    private routeReuseStrategyService: RouteReuseStrategyService
  ) {}

  ngOnInit(): void {
    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(() => {
      this.takeUntilSubject.next(null);
      this.takeUntilSubject.complete();
      this.takeUntilSubject = new Subject();

      this.ngAfterViewInit();
    });
  }

  ngAfterViewInit(): void {
    this.route.params.pipe(
      first(),
      takeUntil(this.takeUntilSubject)
    ).subscribe(params => {
      window['orgMain'].showVirtualEventAttendees(params.id);
      if(window['orgMain'].sendInviteModalEventType){
        window['$']('#panelEventPageInvitationsTab').click();
      }
    });
  }

  ngOnDestroy(): void {
    window["$"]('#vEventAttendees').empty()
    window["$"]('#vEventAttendees').hide()

    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();

    this.takeUntilRouteReuseStrategySubject.next(null);
    this.takeUntilRouteReuseStrategySubject.complete();

    this.routeReuseStrategyService.status = false;
  }

  showRemindersPage() {
    const { scheduler, eventReportInvitationsModal, SchedulerTaskType, EventTypeVirtual, $ }: any = window;
    scheduler.reset();
    scheduler.data = eventReportInvitationsModal.vEvent;
    scheduler.virtualEventId = eventReportInvitationsModal.vEvent.id;
    scheduler.eventPageId = eventReportInvitationsModal.vEvent.eventPageId;

    scheduler.updateEventDateTime();

    const taskTypeList = [
        SchedulerTaskType.PendingCartReminder,
        SchedulerTaskType.VirtualEventReminder,
        SchedulerTaskType.VirtualEventInviteReminder,
        SchedulerTaskType.EventPageInviteReminder
    ];

    let cancelledList = [];
    let scheduledList = [];
    let completedList = [];
    var sortRemindersByStatus = function(reminders) {
        for (let i = 0; i < reminders.length; i++) {
            if(reminders[i].status === 0) 
                scheduledList.push(reminders[i])
            if(reminders[i].status === 2 || reminders[i].status === 3)
                completedList.push(reminders[i])
            if(reminders[i].status === 4)
                cancelledList.push(reminders[i])
        }
    }

    return scheduler.getMultipleTaskListByEventId(scheduler.data.id, EventTypeVirtual, taskTypeList).then(() => {
      sortRemindersByStatus(scheduler.list);

      const recommendations = scheduler.getMultipleRecommendationList(taskTypeList);
        if(recommendations.length < 1) {
            $(`*[data-section="suggestedReminderCard"]`).hide();
        } else {
            $(`*[data-section="suggestedReminderCard"]`).show();
            const recommendationListHTML = scheduler.getRecommendationListHTML(recommendations, 'eventReport');
            $(`*[data-section="suggestedReminderListContainer"]`).html(recommendationListHTML);
        }

        if(scheduledList.length < 1) {
            $(`*[data-section="scheduledReminderCard"]`).hide();
        } else {
            $(`*[data-section="scheduledReminderCard"]`).show();
            const listHTML = scheduler.getScheduledTaskListHTML(scheduledList);
            $(`*[data-section="scheduledReminderListContainer"]`).html(listHTML);
            $('*[data-section="suggestedReminderCard"]').css('order', '1');
        }

        if(completedList.length < 1) {
            $(`*[data-section="completedReminderCard"]`).hide();
        } else {
            $(`*[data-section="completedReminderCard"]`).show();
            const listHTML = scheduler.getScheduledTaskListHTML(completedList);
            $(`*[data-section="completedReminderListContainer"]`).html(listHTML);
            $('*[data-section="suggestedReminderCard"]').css('order', '1');
        }

        if(cancelledList.length < 1) {
            $(`*[data-section="cancelledReminderCard"]`).hide();
        } else {
            $(`*[data-section="cancelledReminderCard"]`).show();
            const listHTML = scheduler.getScheduledTaskListHTML(cancelledList);
            $(`*[data-section="cancelledReminderListContainer"]`).html(listHTML);
            $('*[data-section="suggestedReminderCard"]').css('order', '1');
        }
        
        return null;
    }).then(() => {
        const { vEvent } = eventReportInvitationsModal;

        const timestamp = vEvent.virtualEvent ?
            vEvent.virtualEvent.startDateTimeGmtUnix:
            vEvent.startDateTimeGmtUnix;
        scheduler.timestamp[SchedulerTaskType.VirtualEventReminder] = timestamp;
        scheduler.timestamp[SchedulerTaskType.VirtualEventInviteReminder] = timestamp;
        scheduler.timestamp[SchedulerTaskType.EventPageInviteReminder] = timestamp;
        scheduler.placeOfCall = 'eventReport';

        scheduler.updateReminders();
        return scheduler.init(() => {
            this.showRemindersPage();

            if($("#scheduledReminderHeadingLink").hasClass("collapsed")) {
              $("#scheduledReminderHeadingLink").click();
          }
        });
    })
  }
}
